import { FormikProps, useFormikContext } from 'formik'
import React from 'react'
import {
  CheckBoxFieldv2,
  RadioButtonGroupMapping,
  RadioButtonType,
  RadioButtonsV2,
} from '@labrav/react-components'
import { Typography } from '@mui/material'
import { useStyles } from './FlyOutProductAgreement.styles'
import {
  FlyOutProductAgreementTerm,
  FlyoutProductSections,
} from '../../../types/addEditProduct'

export const FlyOutProductAgreement = () => {
  const { values, setFieldValue, handleChange } =
    useFormikContext() as FormikProps<FlyoutProductSections>
  const { classes } = useStyles()
  const termsData =
    (values as FlyoutProductSections).agreement.terms ||
    ([] as FlyOutProductAgreementTerm[])

  const handleRadioChanges =
    (index: number) => async (event: React.ChangeEvent<HTMLInputElement>) => {
      const selectedValue = event.target.value === 'Yes'
      await setFieldValue(`agreement.terms.${index}.value`, selectedValue)

      if (termsData[index].type === 'radio') {
        if (selectedValue && termsData[index].subTermsWhenTrue) {
          await setFieldValue(
            `agreement.terms.${index}.subTermsWhenTrue.value`,
            false
          )
        } else if (!selectedValue && termsData[index].subTermsWhenFalse) {
          await setFieldValue(
            `agreement.terms.${index}.subTermsWhenFalse.value`,
            false
          )
        }
      }
    }

  return (
    <div className={classes.root} data-testid="terms-modal">
      {termsData.map((term: FlyOutProductAgreementTerm, index: number) => {
        return term.type === 'checkbox' ? (
          <div key={`terms-${index}`} data-testid={'terms'}>
            <CheckBoxFieldv2
              keyName={`agreement.terms.${index}.value`}
              title={term.label}
              value={term.value}
              onChangeBox={handleChange}
            />
          </div>
        ) : (
          <div key={`terms-${index}`} data-testid={'terms'}>
            <div className={classes.radioContainer}>
              <Typography className={classes.radioLabel}>
                {term.label}
              </Typography>
              <RadioButtonsV2
                checkedValue={{
                  key: term.value ? 'Yes' : 'No',
                  value: term.value ? 'Yes' : 'No',
                }}
                name={`agreement.terms.${index}.value`}
                radioButtonMappings={(term?.options || []).map(
                  option =>
                    ({
                      key: option.label,
                      value: option.label,
                      label: option.label,
                      type: RadioButtonType.STANDARD,
                    }) as unknown as RadioButtonGroupMapping
                )}
                handleChange={handleRadioChanges(index)}
              />
            </div>
            {term.value && term.subTermsWhenTrue ? (
              <div
                className={classes.subTerms}
                data-testid={`subTerms-${index}`}
              >
                <CheckBoxFieldv2
                  keyName={`agreement.terms.${index}.subTermsWhenTrue.value`}
                  title={term.subTermsWhenTrue.label}
                  value={term.subTermsWhenTrue.value}
                  onChangeBox={handleChange}
                />
                {term.subTermsWhenTrue.points && (
                  <ol className={classes.terms}>
                    {term.subTermsWhenTrue.points.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ol>
                )}
              </div>
            ) : !term.value && term.subTermsWhenFalse ? (
              <div
                className={classes.subTerms}
                data-testid={`subTerms-${index}`}
              >
                <CheckBoxFieldv2
                  keyName={`agreement.terms.${index}.subTermsWhenFalse.value`}
                  title={term.subTermsWhenFalse.label}
                  value={term.subTermsWhenFalse.value}
                  onChangeBox={handleChange}
                />
                {term.subTermsWhenFalse.points && (
                  <ol className={classes.terms}>
                    {term.subTermsWhenFalse.points.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ol>
                )}
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}
